<template>
  <p class="value-crud-action--delete">
    <modal
      :title="$t('ui.global.delete_title', { name: model })"
      :content="$t('ui.global.delete_confirmation', { name: item.name })"
      :actions="[
        {
          name: 'valid',
          class: 'btn btn-cancel',
          action: model + '.delete.confirm'
        },
        { name: 'cancel', class: 'btn', action: model + '.delete.cancel' }
      ]"
      btn-class="btn btn-tertiary"
      :data-action="model + '.delete'"
      :data-action-id="item.id"
      @action="action"
    >
      {{ $t("ui.global.unassign") }}
    </modal>
  </p>
</template>
<script>
import Modal from "@/components/helpers/Layout/Modal";

export default {
  props: ["item", "model", "column"],
  components: {
    Modal
  },
  methods: {
    action(name) {
      if (name === "valid") {
        this.$emit("itemDelete", this.item);
      }
    }
  },
  computed: {
    routeParams() {
      return { name: this.model + "_delete", params: { id: this.item.id } };
    }
  }
};
</script>
<style lang="scss">
.value-crud-action--delete .btn {
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// CollectionValueDeleteAction.vue?6ad8dff6